var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnexLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 738.104,
    height: 221.545,
    viewBox: "0 0 738.104 221.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "onex-logo",
    transform: "translate(0 0.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M67.145,166.866C25.406,166.866,0,143.275,0,99.721,0,49.514,32.665,10.8,84.082,10.8c39.924,0,67.145,22.382,67.145,63.515C151.227,124.523,120.982,166.866,67.145,166.866ZM45.368,102.141c0,18.147,9.074,28.431,24.8,28.431,24.8,0,35.085-35.69,35.085-55.047,0-15.123-6.049-28.431-23.591-28.431-26.616,0-36.294,33.27-36.294,55.047Z",
    transform: "translate(0 54.654)",
    fill: "#5dba2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M159.89,159.9H116.336L95.164,100.621A153.79,153.79,0,0,1,86.7,72.191a295.75,295.75,0,0,1-5.444,32.06L69.758,160.507H25.6L57.055,11.7h45.368l19.962,58.676c3.629,9.074,6.049,18.752,9.074,28.431a340.1,340.1,0,0,1,5.444-34.48L147.791,12.3h43.553Z",
    transform: "translate(129.256 59.198)",
    fill: "#5dba2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M198.993,46.585H120.96l-4.234,19.357h72.589l-7.259,34.48H109.466l-4.234,21.172H185.08l-7.864,38.714H52L83.455,11.5h122.8Z",
    transform: "translate(262.552 58.188)",
    fill: "#5dba2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M196.6,81.769l36.294,78.638H180.869L171.8,137.421a153.22,153.22,0,0,1-7.259-21.777,172.88,172.88,0,0,1-16.937,24.2l-16.937,21.172H73.8l70.774-78.638L110.094,11.6h49.6l6.049,16.937c3.025,7.864,5.444,16.333,7.864,24.8,5.444-8.469,11.493-18.147,15.728-23.591L203.25,11.6h54.442Z",
    transform: "translate(372.622 58.693)",
    fill: "#5dba2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M126.867,41.57l-12.7-30.245L106.3,8.3l16.937,38.714c1.21,2.42,3.629,3.629,6.049,2.42.6,0,1.21-.6,1.815-1.21l16.937-21.777-18.147-7.864Z",
    transform: "translate(536.717 42.031)",
    fill: "#5dba2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M214.547.124,106.873,30.369c-4.839,1.21-5.444,6.654-1.21,8.469L132.28,50.331,209.708,6.778l-61.1,50.207,43.553,18.147c2.42,1.815,6.049.6,7.864-1.815a2.222,2.222,0,0,0,.6-1.815L218.781,4.358C219.386.729,217.572-.481,214.547.124Z",
    transform: "translate(519.206 0)",
    fill: "#5dba2f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnexLogo);
export default __webpack_public_path__ + "static/media/onex-logo.6e43971225081586970b37be8cb18c41.svg";
export { ForwardRef as ReactComponent };